import type { Auth0SpaJs } from '@wetransfer/authentication.js';

import { AUTH_CALLBACK_PATH } from './constants';

type GlobalAuth0Config = Pick<
  Auth0SpaJs.Auth0ClientOptions,
  'domain' | 'audience' | 'client_id'
>;

export const createConfig = (): Auth0SpaJs.Auth0ClientOptions => ({
  ...(
    window as unknown as {
      __auth0_config__: GlobalAuth0Config;
    }
  ).__auth0_config__,
  redirect_uri: `${location.origin}${AUTH_CALLBACK_PATH}`,
  leeway: 120, // Leeway set to auth0's recommended maximum of two minutes
  useCookiesForTransactions: true,
});
